import { ReactNode } from "react";
import styles from "../aic.module.css";
import { useTableContext } from "../table/TableContextProvider";
import { AioLabel } from "./aioLabel";

interface AioCommentProps<T> {
  id: string;
  editable?: boolean;
  label?: string;
  setValue: (value: T) => void;
  value?: T;
}

/**
 * Comment input component with label.
 *
 * @param props - Destructured parameter object
 * @param props.id - The id for the control
 * @param props.editable - If this comment is editable
 * @param props.label - Optional label text displayed above the comment editor
 * @param props.setValue - Function to update the value
 * @param props.value - Current value
 */
export const AioComment = <T,>({
  id,
  editable,
  label,
  setValue,
  value,
}: AioCommentProps<T>): ReactNode => {
  // Context
  const { state } = useTableContext();
  const Editor = state?.editorProps.Editor;
  return !state || !Editor ? null : (
    <>
      <AioLabel
        id={`${id}-label`}
        label={label}
        htmlFor={`${id}-editor`}
      />
      <div className={styles.aioCommentHolder}>
        <Editor
          id={`${id}-editor`}
          aria-labelledby={`${id}-label`}
          editable={state?.editable && editable !== false}
          setValue={(ret) => setValue(ret as T)}
          value={value}
        />
      </div>
    </>
  );
};

AioComment.displayName = "AioComment";
